import React from 'react';
import { MapPin } from 'lucide-react';

export const LocationText = ({ location }) => {
  if (!location || !location.city) return <span className="text-gray-500">-</span>;
  return (
    <span className="flex items-center gap-1.5 text-sm">
      <MapPin size={13} className="text-red-400 flex-shrink-0" />
      <span className="text-gray-300">{location.city}{location.region ? `, ${location.region}` : ''}</span>
      <span className="text-gray-600">({location.country})</span>
    </span>
  );
};
